//const Backofficebff         : string = "/backofficebff/service/api/v1";
//const BackofficebffV2         : string = "/backofficebff/service/api/v2";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const StoreReturnQuery: any = {
    GetWarehouses: Backofficebff + '/v1/storereturn/get-warehouses',
    GetMusteriUrunIade: Backofficebff + '/v1/storereturn/get-musteri-iade-urun',
};
